/**************************************************
 * Nombre:       Seccion_Nosotros
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Lineas from "./Componentes/Home_Lineas";
import Locales_VerCatalogo from "./Componentes/Locales_VerCatalogo";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Nosotros_Portada from "./Componentes/Nosotros_Portada";
import Home_Indicadores from "./Componentes/Home_Indicadores";
import Nosotros_Inicios from "./Componentes/Nosotros_Inicios";
import Nosotros_Generando from "./Componentes/Nosotros_Generando";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Nosotros = () => {
    const {sTab} = useResponsive()

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Nosotros_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Lineas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Locales_VerCatalogo/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Nosotros_Inicios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sTab ? 14 : 8}}>
                <Nosotros_Generando/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 24}}>
                <Home_Indicadores/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                <Home_Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Nosotros